'use client';

import Image from 'next/image';
import styles from './index.module.less';

interface ShowPhotoProps {
  imageUrl: string;
  isLoading?: boolean;
}

export default function Step1({ imageUrl, isLoading = false }: ShowPhotoProps) {
  return (
    <div className={styles.container}>
      {/* 主图片 */}
      {imageUrl ? (
        <Image
          src={imageUrl}
          alt="image"
          width={232}
          height={232}
          className={styles.image}
          unoptimized
          onError={() => { }}
          onLoad={() => { }}
        />
      ) : (
        <div className={styles.placeholder}>No image URL provided</div>
      )}

      {/* 扫描线效果 - 只在加载时显示 */}
      {isLoading && (
        <div className={styles.scanOverlay}>
          {/* 蓝色扫描线 */}
          <div className={styles.scanLine} />

          {/* 渐变遮罩 */}
          <div className={styles.gradientMask} />
        </div>
      )}
    </div>
  );
}
